<button [matMenuTriggerFor]="userMenu"
  class="flex flex-row items-center gap-3 px-3 w-full"
  [matTooltip]="!expanded() ? userName() : ''" [matTooltipPosition]="'right'" [matTooltipDisabled]="expanded()"
  [class.justify-center]="!expanded()" [class.flex-col]="!expanded()">
 
    <!-- Avatar -->
    <nx-user-avatar [fotoBase64]="userFotoBase64()" [nome]="userName()" size="sm" [class.mb-1]="!expanded()" />

    @if (expanded()) {
    <div class="flex-1 text-left">
      <div class="font-light text-xs text-pmdf-muted-30">{{ userPosto() }} {{ userNomeGuerra() }}</div>
      <div class="font-normal text-sm text-pmdf-muted-55">{{ userUnit() }}</div>
    </div>
    }
    @if (expanded()) {
    <mat-icon class="icon-base text-pmdf-muted-55">expand_more</mat-icon>
    }
 


  <mat-menu #userMenu="matMenu" class="nexus-user-menu">
    <a mat-menu-item routerLink="/perfil" routerLinkActive="active-user-menu-item" class="">
      <mat-icon class="icon-base">person</mat-icon>
      <span class="font-medium">Meu Perfil</span>
    </a>
    @if (flagService.isEnabled('configuracoes')) {
      <a mat-menu-item [routerLink]="'/config'" routerLinkActive="active-user-menu-item"
        class="transition-colors duration-200">
        <mat-icon class="icon-base">settings</mat-icon>
        <span class="font-medium">Configurações</span>
      </a>
    }
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onLogout()" class="">
      <mat-icon class="icon-base">logout</mat-icon>
      <span class="font-medium">Sair</span>
    </button>
  </mat-menu>